'use es6';

import { getAllLayoutSectionTreesAsMap, getModuleLists } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { updateStylesOfLayoutTreeNodes } from 'InpageEditorUI/lib/layoutSection/renderUtils';
import { layoutSectionNodePositionsCleared } from 'InpageEditorUI/redux/actions/layoutSectionDndActions';
import ModuleEditorStore from 'InpageEditorUI/lib/ModuleEditorStore';
import { didLayoutUpdate } from 'layout-dnd-utils/layoutTreeCompare';
import { updateWidthsOfColumns } from 'layout-dnd-utils/render/renderColumns';
import * as layoutTreeChanges from 'layout-dnd-utils/constants/layoutTreeChangeConstants';

// Watch the state for updates in the tree structure and update the DOM when necessary
const layoutSectionUpdateDomMiddleware = store => next => action => {
  const prevState = store.getState();
  const result = next(action);
  const currentState = store.getState();

  // State doesn't contain modules until the first inpageSync happens. (I think)
  if (getModuleLists(prevState) && getModuleLists(currentState)) {
    const prevLayoutSectionTrees = getAllLayoutSectionTreesAsMap(prevState);
    const currentLayoutSectionTrees = getAllLayoutSectionTreesAsMap(currentState);
    const {
      [layoutTreeChanges.CELL_WIDTHS_CHANGED]: cellWidthsChangedResult,
      [layoutTreeChanges.TREE_STRUCTURE_CHANGED]: treeStructureChangedResult,
      [layoutTreeChanges.USER_STYLE_CHANGED]: userStyleChangedResult
    } = didLayoutUpdate(prevLayoutSectionTrees, currentLayoutSectionTrees);
    if (cellWidthsChangedResult) {
      const {
        cellsWithChangedWidth
      } = cellWidthsChangedResult;
      updateWidthsOfColumns(cellsWithChangedWidth);
      // When the width of a cell changes, clear the node positions immediately so
      // the resize handle position can be recomputed and kept in sync
      store.dispatch(layoutSectionNodePositionsCleared());
    }
    if (userStyleChangedResult) {
      const {
        nodesWithChangedStyles
      } = userStyleChangedResult;
      updateStylesOfLayoutTreeNodes(nodesWithChangedStyles);
    }

    // Make sure to remove deleted modules from the ModuleEditorStore
    if (treeStructureChangedResult && treeStructureChangedResult.deletedNodeNames.length) {
      ModuleEditorStore.deleteAll(treeStructureChangedResult.deletedNodeNames);
    }

    // Reset nodePositions if there was any non-structural change in the tree (because REMY is handling
    // clearing node positions on a structural change)
    if (userStyleChangedResult) {
      store.dispatch(layoutSectionNodePositionsCleared());
    }
  }
  return result;
};
export default layoutSectionUpdateDomMiddleware;